export const filterContentProtection = valueToKeep => result => {
  // NOTE: Shaka 4+ uses object representation of the DASH manifest
  if (!result.querySelectorAll) {
    return {
      ...result,
      children: (result.children || []).map(period => ({
        ...period,
        children: (period.children || []).map(node =>
          node.tagName === 'AdaptationSet'
            ? {
                ...node,
                children: (node.children || []).filter(
                  child =>
                    child.tagName !== 'ContentProtection' ||
                    (child.attributes &&
                      typeof child.attributes.schemeIdUri === 'string' &&
                      child.attributes.schemeIdUri.toUpperCase() === valueToKeep),
                ),
              }
            : node,
        ),
      })),
    };
  }

  Array.from(result.querySelectorAll('AdaptationSet ContentProtection'))
    .filter(child => (child.getAttribute('schemeIdUri') || '').toUpperCase() !== valueToKeep)
    .forEach(child => {
      child.parentNode.removeChild(child);
    });

  return result;
};

export const parseAvailabilityStartTime = manifest => {
  if (!manifest) {
    return '';
  }

  return manifest.querySelector('MPD').getAttribute('availabilityStartTime') || '';
};

export const removeNonPlayReadyDRM = filterContentProtection('URN:UUID:9A04F079-9840-4286-AB92-E65BE0885F95');

export const removeNonWidevineDRM = filterContentProtection('URN:UUID:EDEF8BA9-79D6-4ACE-A3C8-27DCD51D21ED');
